import { JSX } from "react";

import { WizardCustomer } from "models/wizard/WizardState";
import { getProjectOwners, getSalesPerson } from "./CustomerInformationHelper";
import SummaryModule from "../summaryModule/SummaryModule";

import "./CustomerInformation.scss";

type Props = {
  onEditClick: () => void;
  customer: WizardCustomer;
  info?: string | JSX.Element;
  collapsed?: boolean;
};

export default function CustomerInformationSummary({
  onEditClick,
  customer,
  info,
  collapsed
}: Props) {
  return (
    <SummaryModule moduleTitle="Kunduppgifter" info={info}>
      <ul className="listStyle">
        <li>Kundnamn: {customer.customerName}</li>
        <li>Kundansvarig: {getSalesPerson(customer)}</li>
        <li>Kundnummer: {customer.id}</li>
        <li>Uppdragsansvariga: {getProjectOwners(customer)}</li>
        <li>Organisationsnummer: {customer.organizationNumber}</li>
        {customer.entraTenantId && <li>Bunden till Microsoft Entra ID: {customer.entraTenantId}</li>}
      </ul>
    </SummaryModule>
  );
}
